<template>
  <v-container class="container--large" fluid>
    <div class="header-container">
      <v-skeleton-loader
        class="header-loading-1"
        :loading="true"
        type="heading"
      />
      <div>
        <card-six :loading="true" />
      </div>
    </div>
    <div class="home-content">
      <div v-if="windowWidth <= 1263" class="home-content__resources-mobile">
        <!-- go to resources - mobile -->
        <v-skeleton-loader
          :loading="true"
          type="heading"
          class="header-loading-2"
        />
        <skeleton-card-list
          class="mt-4"
          type="avatar"
          isCard
          loading
          isResources
          :height="cardHeight"
          :number="3"
          direction="horizontal"
        />
      </div>

      <div class="home-content__videos">
        <!-- videos -->
        <v-skeleton-loader
          :loading="true"
          type="heading"
          class="flex-grow-0 header-full-width header-loading-2"
        />
        <videos-wrapper>
          <skeleton-card-list :loading="true" :isCard="windowWidth <= 1263" :number="8" class="py-5 py-lg-0 flex-nowrap flex-lg-wrap" />
        </videos-wrapper>
      </div>

      <div class="home-content__main">
        <div v-if="windowWidth > 1263">
          <v-skeleton-loader
            :loading="true"
            type="heading"
            class="header-loading-2"
          />
          <skeleton-card-list
            class="mt-4 skeleton-card-resources"
            type="avatar"
            :isCard="true"
            :loading="true"
            direction="horizontal"
          />
          <!-- go to resources - desktop -->
        </div>
        <div class="home-content__section">
          <!-- methodology -->
          <v-skeleton-loader
            :loading="true"
            type="heading"
            class="header-loading-2 mb-lg-8"
          />
          <skeleton-card-list
            class="mt-4 skeleton-methodology flex-nowrap flex-lg-wrap"
            type="avatar"
            :isCard="true"
            :loading="true"
            :number="windowWidth > 1263 ? 3 : 5"
            direction="horizontal"
          />
        </div>
        <div class="home-content__section">
          <!-- foundational reports -->
          <v-skeleton-loader
            :loading="true"
            type="heading"
            class="header-loading-2 mb-lg-7"
          />
          <skeleton-card-list
            type="avatar"
            :withoutMedia="true"
            :loading="true"
            :isCard="true"
            :number="4"
            direction="horizontal"
            class="mt-4 skeleton-foundational-reports flex-nowrap flex-lg-wrap"
          />
        </div>
      </div>
      <div class="home-content__guides">
        <!-- helpful hints -->
        <v-skeleton-loader
          :loading="true"
          type="heading"
          class="header-loading-2"
        />
        <skeleton-card-list
          direction="horizontal"
          type="media"
          :isCard="true"
          :withoutMedia="true"
          :number="5"
          :loading="true"
          class="skeleton-helpful-hints flex-nowrap py-4"
        />
        <div class="home-content__guides-row">
          <!-- tech guides -->
          <div>
            <v-skeleton-loader :loading="true" type="heading" class="header-loading-2 mb-4" />
            <skeleton-card-list
              direction="horizontal"
              type="media"
              class="mt-3  skeleton-helpful-hints flex-nowrap"
              isTechGuide
              isCard
              withoutMedia
              loading
              :number="windowWidth > 1263 ? 3 : 5"
            />
          </div>
          <!-- support assistance -->
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import SkeletonCardList from './CardList.vue';
import CardSix from '../cards/card-6.vue';
import { mapGetters } from 'vuex';
import VideosWrapper from '../videos/VideosWrapper.vue';

export default {
  components: {
    SkeletonCardList,
    CardSix,
    VideosWrapper,
  },
  computed: {
    ...mapGetters(['windowWidth']),
    cardHeight() {
      if (this.windowWidth < 600) {
        return 'calc(calc(100vw - 56px) / 3)';
      }
      if (this.windowWidth < 1263) {
        return 'calc(calc(100vw - 90px) / 3)';
      }
      return 'initial';
    }
  },
};
</script>

<style lang="scss" scoped>
.header-container {
  display: grid;
  column-gap: 8px;
  row-gap: 16px;
  @media (min-width: 1263px) {
    grid-template-columns: 34% 66%;
  }
}
.home-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 52px;
  width: 100%;

  @media (max-width: 1263px) {
    flex-direction: column;
  }
  &__videos {
    max-width: 446px;
    width: 100%;
    margin-right: 16px;
    .flex-grow-0 > .v-skeleton-loader__heading {
      width: 100%;
    }
    @media (max-width: 1263px) {
      max-width: initial;
      margin-right: 0;
    }
  }
  &__main {
    flex: 1;
    width: 100%;
    overflow: hidden;

    @media (max-width: 1263px) {
      overflow: initial;
      flex: initial;
      width: 100%;
      max-width: initial;
      margin-right: 0;
    }
  }
  &__resources-mobile {
    margin-bottom: 32px;
    width: 100%;
    overflow: hidden;
  }
  &__guides {
    width: 100%;
    margin-top: 55px;

    @media (max-width: 1263px) {
      margin-top: 0;
    }
  }
  &__guides-card {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
  }
  &__guides-row {
    margin-top: 38px;
    display: flex;

    > div {
      width: 50%;

      @media (max-width: 1263px) {
        width: 100%;
        margin-top: 40px;
      }
    }
    @media (max-width: 1263px) {
      margin-top: 16px;
      flex-direction: column;
    }
  }
  &__section {
    margin-top: 55px;

    @media (max-width: 1263px) {
      margin-top: 0;
      margin-bottom: 55px;
    }
  }
}
</style>

<style scoped>
.root >>> .v-skeleton-loader__heading {
  background-color: #e4e6eb !important;
}
.v-skeleton-loader {
  width: 100%;
}
.video-outer-wrapper {
  position: relative;
  margin-top: 1.5625rem;
}
.container .content__video-wrapper {
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 24px;
  padding-bottom: 32px;
  padding-top: 50px;
}
.container .content__video-wrapper.mobile {
  background-color: transparent;
  box-shadow: none;
  padding-left: 0;
}

@media screen and (max-width: 960px) {
  .container .content__video-wrapper {
    position: relative;
  }
}
@media (min-width: 1263px) {
  .header-loading-1 {
    display: flex;
    align-items: center;
  }
  .header-loading-1 >>> .v-skeleton-loader__heading {
    margin: unset !important;
    width: 85% !important;
  }
}
</style>
